import { render, staticRenderFns } from "./DeliveredRatio.vue?vue&type=template&id=1a5b5964&"
import script from "./DeliveredRatio.vue?vue&type=script&lang=ts&"
export * from "./DeliveredRatio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports